module.exports = __webpack_public_path__ + "img/pic_2_5.d01e092b.jpg";